import React, { /* useEffect, */ useContext, useState } from "react";
import AgeTab from "./AgeTab";
import DobTab from "./DobTab";
import Tabs from "../../Tabs";
import FieldHeader from "../FieldHeader";
import labels from "../../../data/labels.json";
import data from "../../../consts/age.json";
import Toggle from "../Toggle";

import Context from "../../../components/Regimen/Context";

function useRequired() {
    const [state /* dispatch */] = useContext(Context);
    const required = state.navigationItems.find(
        (item) => item.id === "enter_patient_details",
    ).requiredFields;

    if (!required.includes("PD_HEIGHT")) {
        state.navigationItems
            .find((item) => item.id === "enter_patient_details")
            .requiredFields.push("PD_HEIGHT");
    }

    if (state.PD_AGE < data.minimumAgeForHeight) {
        state.navigationItems.find(
            (item) => item.id === "enter_patient_details",
        ).requiredFields = required.filter(
            (item) => !item.includes("PD_HEIGHT"),
        );
    }
}

function AgePicker({ field }) {
    const [isAge, setIsAge] = useState(true);
    const { age_tab, age_title, dob_tab } = labels?.pages?.regimen;

    const tabItems = [
        {
            id: "age",
            title: age_tab,
            component: <AgeTab />,
        },
        {
            id: "dob",
            title: dob_tab,
            component: <DobTab />,
        },
    ];

    useRequired();

    return (
        <section className="c-age-picker">
            <div className="c-age-picker__header">
                <FieldHeader title={age_title} tooltip={field.tooltip} />

                <Toggle
                    callback={() => setIsAge(!isAge)}
                    isActive={isAge}
                    label={`Switch to ${isAge ? "date of birth" : "age"}`}
                />
            </div>

            {isAge ? <AgeTab /> : <DobTab />}
        </section>
    );
}

export default AgePicker;
